import { modifyPending, modifySuccess, modifyFail,
    getSUserPending,getSUserSuccess,getSUserFail } from "./userModifySlice";
import { fetchSingleUser, userProfileModify  } from "../../../api/userApi";
import Swal from "sweetalert2";

export const userModification = (formData1) => async (dispatch) => {
   
    try {
    
        dispatch(modifyPending());
        const result = await userProfileModify(formData1);
        console.log(result);

        result.status === "success"
            ? dispatch(modifySuccess(result.message))
            : dispatch(modifyFail(result.message));
            
    } catch (error) {
       console.log(error);
        const err = JSON.parse(JSON.stringify(error.error));
         console.log('catch block'+err);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(modifyFail(err.msg));
        Swal.fire(err.msg, '', 'error')
    }

}



export const getSingleUser = (id) => async (dispatch) => {
   //console.log('user id modify'+id);

   try {
    //call the api
   dispatch(getSUserPending);
   const result = await fetchSingleUser(id);
  // const userData=JSON.parse(result.user);
console.log("fetchSingleUser");
console.log(result);
//console.log('getuserpending '+result.user[0].firstName);
/* console.log('getuserpending user '+result.user[0].firstName);
console.log('getuserpending fname '+result.lastName);
console.log('getuserpending lname '+result.user.lastName); */
//console.log('check user profile out if');
   if(result.user[0] && result.user[0].id){
   //console.log('check user profile');
       return dispatch(getSUserSuccess(result.user[0]));
   }
   dispatch(getSUserFail("user is not found"));

  
} catch (error) {
   dispatch(modifyFail(error));

}
   

}